import { BooleanField, Datagrid, EditButton, List, ShowButton, TextField, TextInput } from 'react-admin';

const filters = [<TextInput key="name" label="Name" source="name" alwaysOn />];

const PartnersList = () => (
  <List exporter={false} filters={filters} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid bulkActionButtons={false} rowClick="show" optimized>
      <TextField source="name" label="Name" />
      <TextField source="status" label="Status" />
      <BooleanField source="hasConfig" label="Has config" sortable={false} />
      <TextField source="uuid" label="UUID" sortable={false} />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export default PartnersList;
